// Hook partagé Operation — fetch /api/metier/stats/dashboard-operation.
import { useEffect, useState } from "react";
import { tenantResolu } from "../../utils/tenantResolu";
import { enteteTenant } from "../../utils/enteteTenant";

const API = process.env.REACT_APP_BACKEND_URL;

const getTenant = tenantResolu;

export function useOperationFetch(url = "/api/metier/stats/dashboard-operation", deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    // Sans tenant résolu : AUCUNE requête, état vide explicite (jamais de repli sur un tenant nommé).
    const tenant = getTenant();
    if (!tenant) { setData(null); setError(null); setLoading(false); return () => { cancelled = true; }; }
    const token = localStorage.getItem("session_token");
    const headers = {
      ...enteteTenant(tenant),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
    fetch(`${API}${url}`, { headers, credentials: "include" })
      .then((r) => (r.ok ? r.json() : Promise.reject(`HTTP ${r.status}`)))
      .then((d) => { if (!cancelled) setData(d); })
      .catch((e) => { if (!cancelled) setError(String(e.message || e)); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, deps);

  return { data, loading, error };
}
